import Api from "../axios"

export const getAttendance= async (year, month, employeeId)=>{
    return await Api.get(
      `/get_attendance_detail?year=${year}&month=${month}&employee_id=${employeeId}`
    );
}